import React from 'react'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'
import { EContentRadar } from '@/store/api/Person/Person.types'

interface ContentRadarItemProps {
  title: string
  value?: EContentRadar
  isActive?: boolean
}

export const ContentRadarItem = ({
  title,
  value,
  isActive,
}: ContentRadarItemProps) => {
  const getColor = () => {
    if (isActive && value === EContentRadar.LOW) {
      return SocialMirrorPalette.dynamicGreen
    }
    if (isActive && value === EContentRadar.MEDIUM) {
      return SocialMirrorPalette.dynamicYellow
    }
    if (isActive && value === EContentRadar.HIGH) {
      return SocialMirrorPalette.dynamicRed
    }
    return SocialMirrorPalette.neutralColor30
  }

  return (
    <div className="flex flex-col gap-1">
      <span className="text-base font-medium" style={{ color: getColor() }}>
        {title}
      </span>
      <div
        className="w-9 h-1.5 rounded-full"
        style={{ backgroundColor: getColor() }}
      />
    </div>
  )
}
